module.exports = __webpack_public_path__ + "img/IMG_9638.04b71591.jpg";